import { portalNavigationUrls, mainNavigationUrls } from "./lists";

const handleLoginRouting = (isUserPortalEnabled, redirect) => {
  if (redirect && redirect.startsWith("/")) {
    return redirect;
  } else if (isUserPortalEnabled) {
    return portalNavigationUrls.DASHBOARD;
  } else {
    return mainNavigationUrls.APPS;
  }
};

export default handleLoginRouting;
